import { render } from "./product-item.vue?vue&type=template&id=05ccd9d6"
import script from "./product-item.vue?vue&type=script&lang=js"
export * from "./product-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__